import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useSymptomChecker from 'hooks/useSymptomChecker';
import { useSymptomStore } from 'store/symptom';
import SymptomContainer from './components/SymptomContainer';
import { Textarea } from 'components/ui/textarea';
import { checkSpanishLocale } from 'lib/utils';

export default function SymptomAdditionalDetails() {
  const { t } = useTranslation();
  const questionData = useSymptomStore((store) => store.questionData)?.data;

  const isSpanish = checkSpanishLocale();

  const { onSubmit, isLoading } = useSymptomChecker();

  const [detail, setDetail] = useState('');

  useEffect(() => {
    if (questionData?.user_eng_choices || questionData?.user_spanish_choices) {
      const selected =
        questionData?.[isSpanish ? 'user_spanish_choices' : 'user_eng_choices'];
      setDetail(selected);
    }
  }, [questionData, isSpanish]);

  const onContinue = () => {
    onSubmit({
      eng_choices: detail,
      spanish_choices: detail,
      questionData,
    });
  };
  return (
    <SymptomContainer
      questionData={questionData}
      isLoading={isLoading}
      onContinue={onContinue}
      questionNumber={8}
    >
      <div className='flex-1 mb-10 md:mb-20'>
        <Textarea
          placeholder={`${t('mention_details')}...`}
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          autoFocus
          className='text-sm border-t-0 border-b-2 border-l-0 border-r-0 rounded-none border-primary bg-background focus-visible:ring-0 focus-visible:ring-offset-0'
        />
      </div>
    </SymptomContainer>
  );
}
